import reservation_getters  from "../../base/reservation_getters";
import reservation_mutators from "../../base/reservation_mutators";
import model                from "./../model";
import ReservationAdvance   from "./../components/ReservationAdvance";
import resources            from "./resources";
import steps                from "./../steps";
import validation           from "./../validation";

export default {
    state    : {
        component  : ReservationAdvance,
        steps,
        validation,
        model      : model,
        model_local: {
            reservee_form: {
                model: null
            }
        },
        resources  : resources,
    },
    getters  : {
        ...reservation_getters
    },
    mutations: {
        ...reservation_mutators
    }

}
